import { createReducer, on } from '@ngrx/store';
import * as StartVmixServerActions from '../actions/start-vmix-server.actions';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';

export const startVmixServerFeatureKey = 'startVmixServer';

export interface State {
  record: ProductionInstance | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StartVmixServerActions.startVmixServer, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StartVmixServerActions.startVmixServerSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StartVmixServerActions.startVmixServerFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StartVmixServerActions.clearStartVmixServerState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

